module.exports = __webpack_public_path__ + "static/media/hot_mmgw.3f8143e2.png";